module.exports = __webpack_public_path__ + "img/ribbon.9117132a.svg";